export function requireEnv(value: string | undefined, name: string): string {
  const trimmed = value?.trim();
  if (!trimmed) {
    throw new Error(
      `platform: ${name} is required. Add it to your app .env file (see .env.example).`,
    );
  }
  return trimmed;
}

export function optionalEnv(value: string | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed?.length ? trimmed : undefined;
}

/**
 * Main API base may be an empty string when the app proxies `/api` locally (e.g. recall dev).
 * The variable must still be declared in `.env`.
 */
export function envOrEmpty(value: string | undefined, name: string): string {
  if (value === undefined) {
    throw new Error(
      `platform: ${name} must be set in .env (use an empty value when the app proxies the main API).`,
    );
  }
  return value;
}
